import Spinner, { SpinnerType } from 'legacy/common/components/spinner/Spinner';
import { useState } from 'react';
import { FaCheck } from 'react-icons/fa';
import { useCheckout } from '../../context';
import { useVerifyMembershipCode } from 'api/queries/organizations/memberships-discount';
import { useTranslation } from 'react-i18next';

const SpecialCode = () => {
  const { t } = useTranslation(['checkout']);
  const [formErrorMessage, setFormErrorMessage] = useState<string | null>(null);
  const {
    organization,
    specialCode,
    isLoading,
    applyDiscountCodeAndSave,
    appliedDiscount
  } = useCheckout();
  const [codeValue, setCodeValue] = useState('');

  const resetCode = () => {
    specialCode.code.setCode(null);
    setCodeValue('');
  };

  /**
   * Callback function called when discount code is successfully verified.
   */
  const onVerifyCodeSuccess = (data: { type: string }) => {
    if (data.type === 'discountCode') {
      applyDiscountCodeAndSave(specialCode.code.value);
      resetCode();
    }
  };

  /**
   * Verifies the provided special code whenever it updates.
   */
  const verifiedCodeData = useVerifyMembershipCode(
    organization?.id,
    specialCode.code.value,
    {
      onSuccess: onVerifyCodeSuccess
    }
  );

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormErrorMessage(null);
    specialCode.code.setCode(codeValue);
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCodeValue(e.target.value.trim());
  };

  const errorMessage = verifiedCodeData.error?.message || formErrorMessage;

  // Don't show if discount is already applied
  if (appliedDiscount.data) {
    return null;
  }

  return (
    <div className="flex flex-col md:w-1/3 md:min-w-[350px] px-4">
      <form onSubmit={onSubmit}>
        <label
          htmlFor="specialCodeInput"
          className="text-neutral-900 text-sm font-normal"
        >
          {t('checkout:haveASpecialCode')}
          <div className="relative flex items-center pt-1">
            <input
              id="specialCodeInput"
              type="text"
              placeholder={t('checkout:enterDiscountPrivatePromoterCode')}
              className="w-full border border-neutral-200 rounded-lg p-4 text-neutral-900 text-base font-normal placeholder:text-neutral-500 focus:border-neutral-900 bg-white"
              value={codeValue}
              onChange={onChange}
            />
            {codeValue && (
              <button
                type="submit"
                disabled={isLoading}
                aria-label={t('checkout:applyCode')}
                className="absolute right-[4px] text-black text-xl px-4 py-4 hover:text-black/60 bg-white"
              >
                {isLoading ? (
                  <Spinner type={SpinnerType.DEFAULT} />
                ) : (
                  <FaCheck />
                )}
              </button>
            )}
          </div>
        </label>
        {errorMessage && (
          <div className="text-error pt-2 font-normal text-sm">
            {errorMessage}
          </div>
        )}
      </form>
    </div>
  );
};

export default SpecialCode;
